import { formatInTimeZone } from 'date-fns-tz';

import { getOrdinalNum } from './date-formatter';

export interface BookingDateFormatOptions {
  includeTime?: boolean;
  includeYear?: boolean;
  timeFirst?: boolean;
  shorten?: boolean;
}

/**
 * Formats booking dates with various display options
 * @param startDate - The booking start date
 * @param endDate - The booking end date
 * @param options - Formatting options
 * @returns Formatted booking date string
 */
export const formatBookingDate = (
  startDate: Date,
  endDate: Date,
  options: BookingDateFormatOptions = {}
): string => {
  const {
    includeTime = true,
    includeYear = false,
    timeFirst = false,
    shorten = false,
  } = options;

  const startMonth = parseInt(formatInTimeZone(startDate, 'UTC', 'MM'));
  const endMonth = parseInt(formatInTimeZone(endDate, 'UTC', 'MM'));

  const startDay = getOrdinalNum(
    parseInt(formatInTimeZone(startDate, 'UTC', 'dd'))
  );
  const endDay = getOrdinalNum(
    parseInt(formatInTimeZone(endDate, 'UTC', 'dd'))
  );

  const startYear = formatInTimeZone(startDate, 'UTC', 'yyyy');
  const endYear = formatInTimeZone(endDate, 'UTC', 'yyyy');

  const startTime = includeTime
    ? `${formatInTimeZone(startDate, 'UTC', 'HH:mm')} `
    : '';
  const endTime = includeTime
    ? `${formatInTimeZone(endDate, 'UTC', 'HH:mm')} `
    : '';

  const yearStartStr = includeYear ? ' ' + startYear : '';
  const yearEndStr = includeYear ? ' ' + endYear : '';

  if (startYear === endYear && startMonth === endMonth) {
    if (startDay === endDay) {
      if (timeFirst && includeTime) {
        let res = `${formatInTimeZone(startDate, 'UTC', 'HH:mm')} to ${formatInTimeZone(endDate, 'UTC', 'HH:mm')} on the ${startDay} of ${formatInTimeZone(startDate, 'UTC', 'MMMM')}${yearStartStr}`;
        if (!shorten) {
          res = 'From ' + res;
        }
        return res;
      } else {
        let res = `${startDay} of ${formatInTimeZone(startDate, 'UTC', 'MMMM')}${yearStartStr}`;
        if (includeTime)
          res = `${res} from ${formatInTimeZone(startDate, 'UTC', 'HH:mm')} to ${formatInTimeZone(endDate, 'UTC', 'HH:mm')} `;
        if (!shorten) {
          res = 'The ' + res;
        }
        return res;
      }
    }
    let res = `${startTime}${startDay} to ${endTime}${endDay} of ${formatInTimeZone(startDate, 'UTC', 'MMMM')}${yearStartStr}`;
    if (!shorten) {
      res = 'From ' + res;
    }
    return res;
  } else {
    let res = `${startTime}${startDay} of ${formatInTimeZone(startDate, 'UTC', 'MMMM')}${yearStartStr} to ${endTime}${endDay} of ${formatInTimeZone(endDate, 'UTC', 'MMMM')}${yearEndStr}`;
    if (!shorten) {
      res = 'From ' + res;
    }
    return res;
  }
};
